/**
 * Central Firestore collection names.
 */
export const firestoreCollections = Object.freeze({
  venues: 'venues',
  packages: 'packages',
});
